import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {InicioComponent} from './inicio/inicio.component';
import {PerfilComponent} from './perfil/perfil.component';
import {HomeComponent} from './home/home.component';
import {CadastrarComponent} from './cadastrar/cadastrar.component';
import {LoginComponent} from './login/login.component';
import {AberturaComponent} from './abertura/abertura.component';
import { InstContatoComponent } from './inst-contato/inst-contato.component';
import { InstNegociosComponent } from './inst-negocios/inst-negocios.component';


import { MePerfilComponent } from './me-perfil/me-perfil.component';
import { MePerfilEditarComponent } from './me-perfil-editar/me-perfil-editar.component';
import { MePerfilInserirComponent } from './me-perfil-inserir/me-perfil-inserir.component';
import { MeFichatreinoComponent } from './me-fichatreino/me-fichatreino.component';
import { MeTreinoComponent } from './me-treino/me-treino.component';
import { MeRefeicaoComponent } from './me-refeicao/me-refeicao.component';
import { MeDietaComponent } from './me-dieta/me-dieta.component';
import { MeDietasComponent } from './me-dietas/me-dietas.component';
import { MeCardapioComponent } from './me-cardapio/me-cardapio.component';
import { MeAvaliacaoComponent } from './me-avaliacao/me-avaliacao.component';
import { MeAvaliacoesComponent } from './me-avaliacoes/me-avaliacoes.component';
import { MeEvolucaoComponent } from './me-evolucao/me-evolucao.component';
import { MeTreinosComponent } from './me-treinos/me-treinos.component';
import { MeInboxComponent } from './me-inbox/me-inbox.component';
import { MeInboxchatComponent } from './me-inboxchat/me-inboxchat.component';
import { InboxcontatosComponent } from './inboxcontatos/inboxcontatos.component';

import { PreshopUfComponent } from './preshop-uf/preshop-uf.component';
import { PreshopCidadesComponent } from './preshop-cidades/preshop-cidades.component';
import { ShopHomeComponent } from './shop-home/shop-home.component';
import { ShopCategorizadoComponent } from './shop-categorizado/shop-categorizado.component';
import { ShopProdutoComponent } from './shop-produto/shop-produto.component';
import { ShopCarrinhoComponent } from './shop-carrinho/shop-carrinho.component';

import { PesquisarComponent } from './pesquisar/pesquisar.component';
import { PesquisarResultadosComponent } from './pesquisar-resultados/pesquisar-resultados.component';

import { CadastroValidarComponent } from './cadastro-validar/cadastro-validar.component';
import { LoginPreComponent } from './login-pre/login-pre.component';
import { PesquisarPreComponent } from './pesquisar-pre/pesquisar-pre.component';
import { PesquisarListaresultadoComponent } from './pesquisar-listaresultado/pesquisar-listaresultado.component';
import { InfoLocalComponent } from './info-local/info-local.component';
import { InfoProComponent } from './info-pro/info-pro.component';
import { PremiumSobreComponent } from './premium-sobre/premium-sobre.component';
import { PremiumAssinarComponent } from './premium-assinar/premium-assinar.component';

import { MePerfilFotoComponent } from './me-perfil-foto/me-perfil-foto.component';
import { MePerfilLocalComponent } from './me-perfil-local/me-perfil-local.component';
import { MePerfilLocaisComponent } from './me-perfil-locais/me-perfil-locais.component';
import { MePerfilProfissionaisComponent } from './me-perfil-profissionais/me-perfil-profissionais.component';

import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardHomeComponent } from './dashboard-home/dashboard-home.component';
import { DashboardAtendimentosComponent } from './dashboard-atendimentos/dashboard-atendimentos.component';
import { DashboardAtendimentoComponent } from './dashboard-atendimento/dashboard-atendimento.component';
import { DashboardPlanoComponent } from './dashboard-plano/dashboard-plano.component';
import { DashboardAvaliacoesComponent } from './dashboard-avaliacoes/dashboard-avaliacoes.component';
import { DashboardAvaliacaoComponent } from './dashboard-avaliacao/dashboard-avaliacao.component';
import { DashboardPacientesComponent } from './dashboard-pacientes/dashboard-pacientes.component';
import { DashboardPacienteComponent } from './dashboard-paciente/dashboard-paciente.component';
import { DashboardNovoatendimentoComponent } from './dashboard-novoatendimento/dashboard-novoatendimento.component';
import { DashboardNovoplanoComponent } from './dashboard-novoplano/dashboard-novoplano.component';
import { DashboardAddrefeicaoComponent } from './dashboard-addrefeicao/dashboard-addrefeicao.component';
import { DashboardRefeicaoComponent } from './dashboard-refeicao/dashboard-refeicao.component';
import { DashboardAddtreinoComponent } from './dashboard-addtreino/dashboard-addtreino.component';
import { DashboardTreinoComponent } from './dashboard-treino/dashboard-treino.component';
//import { DashboardAvaliacaonovaComponent } from './dashboard-avaliacaonova/dashboard-avaliacaonova.component';
import { PerfilDetalhesComponent } from './perfil-detalhes/perfil-detalhes.component';
import { PerfilItemComponent } from './perfil-item/perfil-item.component';

import { MeConfiguracoesComponent } from './me-configuracoes/me-configuracoes.component';
import { ShopEnderecoComponent } from './shop-endereco/shop-endereco.component';
import { ShopEnderecosComponent } from './shop-enderecos/shop-enderecos.component';
import { ShopFinalizadoComponent } from './shop-finalizado/shop-finalizado.component';
import { ShopCheckoutComponent } from './shop-checkout/shop-checkout.component';
import { ShopPedidosComponent } from './shop-pedidos/shop-pedidos.component';
import { ShopPedidoComponent } from './shop-pedido/shop-pedido.component';

import { DashboardAderenciaComponent } from './dashboard-aderencia/dashboard-aderencia.component';
import { DashboardComparacaoComponent } from './dashboard-comparacao/dashboard-comparacao.component';
import { DashboardComparacaotreinoComponent } from './dashboard-comparacaotreino/dashboard-comparacaotreino.component';
import { DashboardAderenciatreinoComponent } from './dashboard-aderenciatreino/dashboard-aderenciatreino.component';
import { DashboardPacienteNovoComponent } from './dashboard-paciente-novo/dashboard-paciente-novo.component';

import { RecuperarSenhaComponent } from './recuperar-senha/recuperar-senha.component';

import { MeNotificacoesComponent } from './me-notificacoes/me-notificacoes.component';
import { MeNotificacaoComponent } from './me-notificacao/me-notificacao.component';

import { MeReceitasComponent } from './me-receitas/me-receitas.component';
import { MeReceitaComponent } from './me-receita/me-receita.component';
import { ShopAvaliarComponent } from './shop-avaliar/shop-avaliar.component';
import { MeFeedComponent } from './me-feed/me-feed.component';
import { MePostComponent } from './me-post/me-post.component';
import { MePostnewComponent } from './me-postnew/me-postnew.component';
import { LoginIntegradoComponent } from './login-integrado/login-integrado.component';
import { InsttermosComponent } from './insttermos/insttermos.component';
import { InstExcluirComponent } from './instexcluir/instexcluir.component';

const routes: Routes = [
    {path: 'auth-tamasapp/:token/:so/:email/:senha/:destino', component: LoginIntegradoComponent },
    {path: '', redirectTo: '/abertura', pathMatch: 'full'},
    {path: 'inicio',      component: InicioComponent, data: { routeIdx: 0 } },
    //{path: 'perfil', component: PerfilComponent, data: { animation: { value: 'perfil' }} },
    {path: 'home', component: HomeComponent, data: { routeIdx: -1 } },
    {path: 'abertura', component: AberturaComponent, data: { routeIdx: -1 } },
    {path: 'abertura/:token/:so', component: AberturaComponent, data: { routeIdx: -1 } },
    {path: 'autenticar', component: LoginPreComponent,  data: { routeIdx: 0 }},
    //caso forneça os dados abaixo, armazenamos no ls
    {path: 'autenticar/:token/:so/:destino', component: LoginPreComponent,  data: { routeIdx: 0 }},
    {path: 'login', component: LoginComponent,  data: { routeIdx: 1 }},
    
    {path: 'cadastrar', component: CadastrarComponent,  data: { routeIdx: 2 }},
    {path: 'recuperar-senha/:email/:codigo', component: RecuperarSenhaComponent,  data: { routeIdx: 2 }},

    {path: 'meu-cadastro/s/:etapa/:idcadastrado/:parametroextra', component: CadastroValidarComponent,  data: { routeIdx: 3 } },
    //apos validar, pedir o estado e cidade
    //depois oferecer opção inserir foto ou pular
    //conquistas algo pra explicar (primeira vez)
    //
    {path: 'excluir-conta', component: InstExcluirComponent,  data: { routeIdx: 3 } },
    {path: 'contato', component: InstContatoComponent,  data: { routeIdx: 3 } },
    {path: 'negocios', component: InstNegociosComponent,  data: { routeIdx: 3 } },
    {path: 'termos-de-uso', component: InsttermosComponent,  data: { routeIdx: 3 } },
    //premium
    {path: 'premium', component: PremiumSobreComponent,  data: { routeIdx: 3 } },
    {path: 'seja-premium/:idplano', component: PremiumAssinarComponent,  data: { routeIdx: 4 } },


    {path: 'me/receitas', component: MeReceitasComponent, data: { routeIdx: 5 } },
    {path: 'me/receita/:receita', component: MeReceitaComponent, data: { routeIdx: 6 } },
    //editar perfil, completar cadastro, alguns botões:
    //modalidades: uma lista com todas, pesquisar no topo e ao lado de cada uma o checkbox, embaixo o botão salvar
    //conquistas: listar as que tiver cadastradas, caso não tenha, exibir botão add conquista
    //ir para uma nova view, cadastrar a conquista (fields? titulo, ano ++) e abaixo SALVAR
    //descricao até 300 char perfil
    {path: 'me/settings', component: MeConfiguracoesComponent, data: { routeIdx: 5 } },
    {path: 'me/perfil', component: MePerfilComponent, data: { routeIdx: 4 } },
    {path: 'me/perfil/editar/:tipoedit', component: MePerfilEditarComponent, data: { routeIdx: 5 } },
    //{path: 'me/perfil/add/:tipoadd', component: MePerfilInserirComponent, data: { routeIdx: 6 } },
    //onde treina etc
    {path: 'me/perfil/locais', component: MePerfilLocaisComponent, data: { routeIdx: 5 } },
    {path: 'me/perfil/profissionais', component: MePerfilProfissionaisComponent, data: { routeIdx: 5 } },


    {path: 'me/perfil/local', component: MePerfilLocalComponent, data: { routeIdx: 5 } },
    {path: 'me/perfil/foto', component: MePerfilFotoComponent, data: { routeIdx: 6 } },
    //listar fichas de treino
    {path: 'me/treinos', component: MeTreinosComponent, data: { routeIdx: 0 }},
    //ficha especifica com o nome dos treinos de cada dia (PEITO, COSTA, BICEPS ETC)
    {path: 'me/fichatreino/:idficha', component: MeFichatreinoComponent, data: { routeIdx: 1 } },
    //treino do dia algo do tipo?
    {path: 'me/treino/:idficha/:idtreino', component: MeTreinoComponent, data: { routeIdx: 2 } },

    //MeNotificacoesComponent
    {path: 'me/notificacoes', component: MeNotificacoesComponent, data: { routeIdx: 2 } },
    {path: 'me/notificacao/:tipo/:idnotificacao', component: MeNotificacaoComponent, data: { routeIdx: 3 } },

    //listar todas - data, profissional e etc
    //ver como liberar o acesso
    {path: 'me/dietas', component: MeDietasComponent, data: { routeIdx: 1 } },
     //dieta especifica, ter os dias da semana (ds)
     {path: 'me/dieta/:iddieta/:fatorsemana', component: MeDietaComponent, data: { routeIdx: 2 } },
    //trazer as refeições do dia, com base no ds, pensar como dar check
    //como buscar um dia do mes em especifico?
    {path: 'me/cardapio/:iddieta/:diadasemana/:datacompleta', component: MeCardapioComponent, data: { routeIdx: 3 } },

    {path: 'me/refeicao/:iddieta/:diadasemana/:idrefeicao/:diadomes', component: MeRefeicaoComponent, data: { routeIdx: 4 } },
    //check if premium ok - else check id last avaliacao
    {path: 'me/avaliacao/:idavaliacao', component: MeAvaliacaoComponent, data: { routeIdx: 4 }  },
    //lista com todas avaliacoes, order by date
    //se premium já libera o click
    //não premium, exibe algo para tornar-se premium
    {path: 'me/avaliacoes', component: MeAvaliacoesComponent, data: { routeIdx: 3 }  },

    //quando comparar avaliacoes, separar os ids por - , ex: 1-3-11
    {path: 'me/evolucao/:idsavaliacoes', component: MeEvolucaoComponent, data: { routeIdx: 5 }  },

    //overall/ ano, algo pre definido
    //{path: 'me/evolucao/:periodo', component: MeEvolucaoComponent, data: { routeIdx: 5 }  },

    //social
    {path: 'me/feed', component: MeFeedComponent, data: { routeIdx: 3 } },    
    {path: 'me/post/:nickuser/:postid', component: MePostComponent, data: { routeIdx: 6 } },
    //aqui vamos variar entre a tela da foto e depois a de escrevero texto com o botão publicar
    {path: 'me/create/:tela', component: MePostnewComponent, data: { routeIdx: 7 } },


    {path: 'me/inbox', component: MeInboxComponent, data: { routeIdx: 2 } },
    {path: 'me/i/:nomeusuario', component: MeInboxchatComponent, data: { routeIdx: 4 } },
    {path: 'me/contatos/listar', component: InboxcontatosComponent, data: { routeIdx: 3 } },
    
    //criar uma pre-view para escolher oq buscar
    {path: 'pesquisar', component: PesquisarPreComponent, data: { routeIdx: 0 } },
    //se for pessoas - digitar + pesquisar
    //se for local ou pro -> escolher uf/cidade (ou ir direto);
    {path: 'pesquisando/:tipopesquisa', component: PesquisarComponent, data: { routeIdx: 2 } },
    //aqui é para pesquisas do tipo nome ou nomeusuario
    {path: 'resultados/:parametrobusca', component: PesquisarResultadosComponent, data: { routeIdx: 3 } },

    //o tipo a ser buscado é um parametro
    //tipobusca = locais, profissionais ou outro/
    //subtipo se profissional uma possível categoria, enquanto não tiver, usar todos

    {path: 'listar/:tipobuscado/:subtipo/:uf/:cidade', component: PesquisarListaresultadoComponent, data: { routeIdx: 3 } },

    //tipo de local na url?, se tipo = todos sem problema
    {path: 'locais/:tipolocal/:uf/:cidade', component: CadastrarComponent, data: { animation: { value: 'reslocais' }} },
    //tipo de profissional na url? se tipo = todos sem problema
    {path: 'profissionais/:profissional/:uf/:cidade', component: CadastrarComponent, data: { animation: { value: 'respro' }} },

    
    //url amigável, permitir nomeusuario para o profissional
    {path: 'pro/:nomepro', component: InfoProComponent, data: { routeIdx: 8 }},

    //url amigável para o local?
    {path: 'local/:nomelocal', component: InfoLocalComponent, data: { routeIdx: 8 }},


   

    //loja
    {path: 'pre-shop/uf', component: PreshopUfComponent, data: { routeIdx: 1 } },
    {path: 'pre-shop/cidades/:uf', component: PreshopCidadesComponent,  data: { routeIdx: 2 } },
    //exibir produtos a venda naquela cidade
    {path: 'shop/:uf/:cidade', component: ShopHomeComponent,  data: { routeIdx: 4 } },
    //produtos com o filtro da categoria pai
    {path: 'shopping/:uf/:cidade/:qcategoria', component: ShopCategorizadoComponent,  data: { routeIdx: 5 } },
    {path: 'shopping/:uf/:cidade/:qcategoria/produto/:idproduto', component: ShopProdutoComponent,  data: { routeIdx: 6 } },
    //{path: 'shopping/produto/:idproduto', component: ShopProdutoComponent,  data: { routeIdx: 5 } },
    {path: 'shopping/carrinho', component: ShopCarrinhoComponent,  data: { routeIdx: 6 } },
    {path: 'shopping/endereco', component: ShopEnderecoComponent,  data: { routeIdx: 7 } },
    {path: 'shopping/checkout', component: ShopCheckoutComponent,  data: { routeIdx: 8 } },
    {path: 'shopping/finalizado', component: ShopFinalizadoComponent,  data: { routeIdx: 9 } },
    {path: 'shopping/pedidos', component: ShopPedidosComponent,  data: { routeIdx: 4 } },
    {path: 'shopping/pedido/:id', component: ShopPedidoComponent,  data: { routeIdx: 5 } },
    {path: 'shopping/avaliar/:id', component: ShopAvaliarComponent,  data: { routeIdx: 6 } },
    //painel pro
    
    {path: 'dashboard', component: DashboardComponent, data: { routeIdx: 1 },
    children: [
      { path: 'home', component: DashboardHomeComponent },
      {path: 'pacientes/:tipo/:parametrobusca', component: DashboardPacientesComponent, data: { routeIdx: 2 }},
      {path: 'paciente/:idpaciente', component: DashboardPacienteComponent, data: { routeIdx: 3 } },
      {path: 'novo-paciente', component: DashboardPacienteNovoComponent, data: { routeIdx: 2 }},
      { path: 'paciente/:idpaciente/avaliacao/:idavaliacao', component: DashboardAvaliacaoComponent, data: { routeIdx: 5 } },
      //{path: 'paciente/:nomepaciente/add-avaliacao', component: DashboardAvaliacaonovaComponent, data: { routeIdx: 4 } },
      {path: 'paciente/:idpaciente/novo-plano', component: DashboardNovoplanoComponent, data: { routeIdx: 5 } },
      {path: 'add-refeicao/:idpaciente/:idplano', component: DashboardAddrefeicaoComponent, data: { routeIdx: 6 } },
      {path: 'add-treino/:idpaciente/:idplano', component: DashboardAddtreinoComponent, data: { routeIdx: 6 } },
      {path: 'treino/:idpaciente/:idplano/:idtreino', component: DashboardTreinoComponent, data: { routeIdx: 7 } },
      {path: 'refeicao/:idpaciente/:idplano', component: DashboardRefeicaoComponent, data: { routeIdx: 7 } },
      {path: 'desempenho/:idpaciente/:idplano', component: DashboardAderenciaComponent, data: { routeIdx: 4 } },
      {path: 'comparacao/:idpaciente', component: DashboardComparacaoComponent, data: { routeIdx: 4 } },
      {path: 'desempenho-treino/:idpaciente/:idplano', component: DashboardAderenciatreinoComponent, data: { routeIdx: 4 } },
      { path: 'atendimentos/:tipo', component: DashboardAtendimentosComponent, data: { routeIdx: 2 } }
  ] },


    //para o profissional ter um controle, saber quantos atendimentos ele realizou, pensar como filtrar, data in, data fim ou X dias
    {path: 'dashboard/atendimentos/:tipofiltro/:datastart/:dataend', component: DashboardAtendimentosComponent, data: { routeIdx: 2 } },
    //no filtro traremos a data e o nome do paciente, ao clicar irá para os detalhes completo
    {path: 'dashboard/atendimento/:idatendimento', component: DashboardAtendimentoComponent, data: { routeIdx: 3 } },
    //dentro das info do atendimento, terá um link para o plano (idplano), que pode ser tanto treino quanto alimentar
    //identificar o tipo
    {path: 'dashboard/plano/:idplano', component: DashboardPlanoComponent, data: { routeIdx: 4 } },
    {path: 'dashboard/avaliacoes/:nomepaciente', component: DashboardAvaliacoesComponent, data: { routeIdx: 4 } },
    //{path: 'dashboard/paciente/:nomepaciente/avaliacao/:idavaliacao', component: DashboardAvaliacaoComponent, data: { routeIdx: 5 } },
    //{path: 'dashboard/paciente/:nomepaciente/add-avaliacao', component: DashboardAvaliacaonovaComponent, data: { routeIdx: 4 } },
    //dentro da view do atendimento, terá um link para visualizar 
    //buscar pacientes / exibir pacientes
    //{path: 'dashboard/pacientes/:tipo/:parametrobusca', component: DashboardPacientesComponent, data: { routeIdx: 2 } },
    //aqui considerar aquela relação pro aluno
    //{path: 'dashboard/paciente/:nomepaciente', component: DashboardPacienteComponent, data: { routeIdx: 3 } },
    //após entrar no perfil do paciente (se já existir a relação pro - aluno), exibe info básicas e embaixo a lista dos atendimentos
    //clica no atendimento vai para atendimento/id
    //avaliação é atrelada ao atendimento
    //criar novo atendimento, primeiro escolher o paciente
    {path: 'dashboard/paciente/:nomepaciente/novo-atendimento', component: DashboardNovoatendimentoComponent, data: { routeIdx: 4 } },
    //treino ou dieta, carregar de acordo com o TipoProfissional cadastrado
   //{path: 'dashboard/paciente/:nomepaciente/novo-plano', component: DashboardNovoplanoComponent, data: { routeIdx: 5 } },
    //se for um plano criado por nutricionista aparece opção para addd refeição
    //dentro da refeição, teremos um checklist para determinar quais dias se repetirá aquela refeição
    //no topo terá TODOS, ou então pode ir de 1 em 1
    //{path: 'dashboard/add-refeicao/:nomepaciente/:idplano', component: DashboardAddrefeicaoComponent, data: { routeIdx: 6 } },
    //verificar agora a parte de treino, addexercicios talvez
    //dentro do treino teremos os campos para add exercício, tempo descanso etc
    //aquela opção de gerar os campos diretamente no html, ou salvar e limpar
    //{path: 'dashboard/add-treino/:nomepaciente/:idplano', component: DashboardAddtreinoComponent, data: { routeIdx: 6 } },

    //visualizar / editar treino e refeição
    // {path: 'dashboard/treino/:nomepaciente/:idplano/:idtreino', component: DashboardTreinoComponent, data: { routeIdx: 7 } },
    // {path: 'dashboard/refeicao/:nomepaciente/:idplano/:idrefeicao', component: DashboardRefeicaoComponent, data: { routeIdx: 7 } },


     //perfil do cara
     {path: ':nomeusuario', component: PerfilComponent, data: { routeIdx: 5 } },
     {path: ':nomeusuario/add/:tipoadd', component: MePerfilInserirComponent, data: { routeIdx: 7 } },
     //views referente ao cara, listar modalidades, conquistas
     {path: ':nomeusuario/:itemlistar', component: PerfilDetalhesComponent, data: { routeIdx: 6 } },
     //item dos detalhes, tipo conquista etc
     {path: ':nomeusuario/:itemlistar/:iditem', component: PerfilItemComponent, data: { routeIdx: 7 } },
    {path: '**', redirectTo: 'abertura', pathMatch: 'full'}
  ];
  
@NgModule({
  //imports: [ RouterModule.forRoot(routes, {  scrollOffset: [0, 0], scrollPositionRestoration: 'enabled'}) ],
  
  imports: [ RouterModule.forRoot(routes)],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
